import { publicApi, protectedApi } from '../config/api.config';

class AmicaleApi {
  static async checkUrl(baseUrl) {
    try {
      const response = await publicApi.get('/amicales/check', {
        params: { baseUrl },
      });
      return response.data;
    } catch (error) {
      console.warn('[AmicaleApi] checkUrl failed:', error?.message || error);
      return { isAmical: false, client: null };
    }
  }

  /** Fetch the Resabeds A4 background as a base64 data URI (cached in memory). */
  static _bgCache = null;
  static async getVoucherBgDataUri() {
    if (AmicaleApi._bgCache) return AmicaleApi._bgCache;
    try {
      const response = await publicApi.get('/amicales/voucher-bg');
      AmicaleApi._bgCache = response.data?.dataUri || null;
      return AmicaleApi._bgCache;
    } catch {
      return null;
    }
  }

  /** Granted cartes d'accès / bien-être for the connected amicale moteur session. */
  static async getMoteurCartesAccess() {
    const response = await protectedApi.get('/amicales/moteur/cartes-access');
    return response.data;
  }
}

export default AmicaleApi;
